module.exports = __webpack_public_path__ + "static/img/1.33c6f57.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/zh/1.png
// module id = fAPV
// module chunks = 0